var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dry-power"},[_c('moduleTitle',{attrs:{"title":"仓储监控"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }